var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNounLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600 237.84c66.844 0 130.92 26.531 178.18 73.828 47.297 47.25 73.828 111.33 73.828 178.18 0 66.844-26.531 130.92-73.828 178.18-47.25 47.297-111.33 73.828-178.18 73.828s-130.92-26.531-178.18-73.828c-47.297-47.25-73.828-111.33-73.828-178.18 0-66.844 26.531-130.92 73.828-178.18 47.25-47.297 111.33-73.828 178.18-73.828zm-10.688 883.08 10.688 12c57.609-67.453 114.7-134.76 176.16-201.71 120-130.45 247.69-270.14 247.69-441.47v-0.046876c0-151.4-80.766-291.32-211.92-367.03-131.16-75.703-292.69-75.703-423.84 0-131.16 75.703-211.92 215.63-211.92 367.03 0 172.69 129.84 312.94 249.94 444 57.047 62.906 110.06 124.92 163.22 187.22z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounLocation);
export default __webpack_public_path__ + "static/media/noun-location.b4a8823539dc0320b730905fb7230853.svg";
export { ForwardRef as ReactComponent };